
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/[id]",
      function () {
        return require("private-next-pages/book/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/[id]"])
      });
    }
  